import thunk from "redux-thunk";
import { routerMiddleware } from "connected-react-router";
import { createStore, applyMiddleware, compose } from "redux";

import { homepage } from "../package.json";
import { createBrowserHistory } from "history";
import rootReducer from "./modules/redux/rootReducer";

export const history = createBrowserHistory({ basename: homepage });

const enhancers = [];
const initialState = {};
const middleware = [thunk, routerMiddleware(history)];

if (process.env.NODE_ENV === "development") {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;
  if (typeof devToolsExtension === "function") {
    enhancers.push(devToolsExtension());
  }
}

const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);

const store = createStore(
  rootReducer(history),
  initialState,
  composedEnhancers,
);

export default store;
